export const BUDGET_STATUS = {
    DRAFT:      0,
    SENT:       1,
    CANCELLED:  2,
    CLOSED:     3,
};